import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["name", "placeholder", "disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return _withDirectives((_openBlock(), _createElementBlock("input", {
        name: _ctx.name,
        type: "text",
        "data-lpignore": "true",
        placeholder: _ctx.placeholder,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formattedPhone) = $event)),
        onKeyup: _cache[1] || (_cache[1] =
            //@ts-ignore
            (...args) => (_ctx.onKeyup && _ctx.onKeyup(...args))),
        onBlur: _cache[2] || (_cache[2] =
            //@ts-ignore
            (...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        onChange: _cache[3] || (_cache[3] =
            //@ts-ignore
            (...args) => (_ctx.onChange && _ctx.onChange(...args))),
        onEnter: _cache[4] || (_cache[4] =
            //@ts-ignore
            (...args) => (_ctx.onEnter && _ctx.onEnter(...args))),
        disabled: _ctx.disabled
    }, null, 40, _hoisted_1)), [
        [_vModelText, _ctx.formattedPhone]
    ]);
}
